import { render, staticRenderFns } from "./HealthForm.vue?vue&type=template&id=bdd8118a&scoped=true"
import script from "./HealthForm.vue?vue&type=script&lang=js"
export * from "./HealthForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd8118a",
  null
  
)

export default component.exports